import { post } from './baseUrl';
import { ApiEndpoint } from './endpoints';

export type UpdateClinicianProfileContactRequest = {
  clinicianProfileDetails: Record<string, any>;
};

export const updateClinicianProfileContact = async (
  request: UpdateClinicianProfileContactRequest,
) => {
  const response = await post(
    ApiEndpoint.updateClinicianProfileContact,
    request,
  );
  return response.data;
};
